
const airports = [
  {
    id: 1,
    name: 'Heathrow Airport',
    code: 'LHR',
    distance: '15 miles from Central London',
    price: 'From £45',
    time: '45-60 mins',
  },
  {
    id: 2,
    name: 'Gatwick Airport',
    code: 'LGW',
    distance: '30 miles from Central London',
    price: 'From £65',
    time: '60-90 mins',
  },
  {
    id: 3,
    name: 'Stansted Airport',
    code: 'STN',
    distance: '40 miles from Central London',
    price: 'From £75',
    time: '70-90 mins',
  },
  {
    id: 4,
    name: 'Luton Airport',
    code: 'LTN',
    distance: '35 miles from Central London',
    price: 'From £70',
    time: '60-80 mins',
  },
];

const features = [
  { icon: 'ri-user-smile-line', title: 'Meet & Greet', desc: 'Driver waits at arrivals' },
  { icon: 'ri-car-line', title: 'Family Vehicles', desc: 'Spacious MPVs available' },
  { icon: 'ri-flight-land-line', title: 'Flight Tracking', desc: 'We monitor your flight' },
  { icon: 'ri-24-hours-line', title: '24/7 Service', desc: 'Any time, any day' },
];

export default function AirportTransfers() {
  return (
    <section id="transfers" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-2 bg-[#C9A961]/10 text-[#C9A961] text-sm font-medium rounded-full mb-4">
              Airport Transfers
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F2E] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Reliable Airport Transfer Services
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Start your London journey stress-free with our professional airport transfer service. Our drivers speak Urdu and English, ensuring comfortable communication for Pakistani families arriving in the UK.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-12 h-12 bg-[#FFF8E7] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-xl text-[#C9A961]`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A1F2E]">{feature.title}</h4>
                    <p className="text-sm text-gray-500">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-8 py-4 bg-[#C9A961] text-white rounded-lg font-semibold hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Your Transfer
            </button>
          </div>

          <div className="space-y-4">
            {airports.map((airport) => (
              <div
                key={airport.id}
                className="bg-[#FAFAFA] rounded-2xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 bg-[#1A1F2E] rounded-xl flex items-center justify-center">
                      <span className="text-white font-bold text-sm">{airport.code}</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A1F2E] group-hover:text-[#C9A961] transition-colors">{airport.name}</h3>
                      <p className="text-sm text-gray-500">{airport.distance}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-[#C9A961]">{airport.price}</p>
                    <p className="text-sm text-gray-500">{airport.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
